import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellphonesService } from './logic/cellphones.service';
import { CellphonesLogicService } from './logic/cellphones/cellphones-logic.service';
import { CellphonesDaoService } from './dao/cellphones-dao.service';
import { CellphonesDbDaoService } from './dao/cellphones-dao/cellphones-db-dao.service';
import { CellphoneDbTableDefinition } from './dao/cellphones-dao/cellphone-db-table-definition';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    { provide: CellphonesService, useClass: CellphonesLogicService },
    { provide: CellphonesDaoService, useClass: CellphonesDbDaoService },
    { provide: CellphoneDbTableDefinition },
  ],
})
export class CellphonesModule {}
